import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { toast } from "sonner";
import { MapPin } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { processOAuthSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get("session_id");

      if (!sessionId) {
        toast.error("Invalid authentication response");
        navigate("/login");
        return;
      }

      try {
        await processOAuthSession(sessionId);
        toast.success("Welcome to Loocator for India!");
        // Clear hash from URL and navigate to home
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (error) {
        console.error("OAuth error:", error);
        toast.error("Authentication failed. Please try again.");
        navigate("/login");
      }
    };

    processSession();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-16 h-16 bg-sky-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <MapPin className="text-sky-600 animate-pulse" size={32} />
        </div>
        <h2 className="text-xl font-semibold text-slate-900 mb-2">Signing you in...</h2>
        <p className="text-slate-500">Please wait a moment</p>
        <div className="mt-6 flex justify-center">
          <div className="w-8 h-8 border-3 border-sky-200 border-t-sky-600 rounded-full animate-spin" />
        </div>
      </div>
    </div>
  );
}
